import { RouteComponentProps } from '@reach/router';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { includes } from 'ramda';
import React from 'react';

import { useAuth } from '@providers/AuthProvider';

import Layout from '../Layout';

interface PrivateRouteProps extends RouteComponentProps {
	component: React.ElementType;
	[x: string]: any;
	addQueryParams?: boolean;
}

const PrivateRoute = ({
	component: Component,
	location,
	addQueryParams = false,
	...rest
}: PrivateRouteProps) => {
	const { loggedIn, initialized } = useAuth();

	if (!initialized) {
		return <div>Loading...</div>;
	}

	if (initialized && !loggedIn) {
		navigate('/app/sign_in', {
			state: {
				redirectTo: addQueryParams
					? `${location?.pathname}${location?.search}`
					: location?.pathname ?? '/',
			},
			replace: true,
		});
		return <div />;
	}

	return (
		<Layout>
			<Component {...rest} />
		</Layout>
	);
};

export default PrivateRoute;
